import React from "react";
const getFillColor = (color: string) => {
  return color === "currentColor" ? `` : `var(--color-${color})`;
};
const SvgStarIcon = ({ title, theme = null, titleId = "", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 64 64"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M62.948 24.682A1 1 0 0 0 62 24H39.731L32.953 2.659a1 1 0 0 0-1.906 0L24.269 24H2a1 1 0 0 0-.6 1.8l17.77 13.426-6.991 21.503a1 1 0 0 0 1.539 1.118L32 48.564l18.282 13.283a1 1 0 0 0 1.539-1.118l-6.988-21.505L62.6 25.8a1 1 0 0 0 .348-1.118Z" />
  </svg>
);
export interface Props {
  color?: string;
  width?: string;
  height?: string;
  title: string;
  titleId?: string;
  theme?: any;
  fill?: string;
}
const SvgStarStyle = ({
  color = "currentColor",
  title,
  fill,
  ...props
}: Props) => (
  <SvgStarIcon
    color={getFillColor(color)}
    className={color === "currentColor" ? "icon-current-color" : ""}
    {...(color !== "currentColor"
      ? { style: { color: getFillColor(color), fill: getFillColor(color) } }
      : null)}
    fill={fill ?? getFillColor(color)}
    title={title}
    {...props}
  />
);
export const StarIcon: any = SvgStarStyle;
export default StarIcon;
